import * as yup from 'yup';

export const validationSchema = yup.object({
    expenseDate: yup.date().typeError("Must be a valid date").required("Required"),
    accountTitle: yup.string().required("Required"),
    amount: yup.number().typeError("Must be a valid number").required("Required"),
})